
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  CostLabor,
  CostsApi,
  ValidationProblemDetails,
  Workorder
} from 'performo-api';

import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    api: 'costsApi'
  })
})
export default class UpdateCostLabor extends Vue {
  private api!: CostsApi;

  @Prop({ required: true })
  private labor!: CostLabor;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  private popoverOpen = false;

  private editedItem: CostLabor = {
    laborDate: this.labor.laborDate,
    laborHours: this.labor.laborHours,
    laborName: this.labor.laborName
  };

  private async editLabor() {
    if (this.labor.costId && this.editedItem.laborDate) {
      try {
        var editedLaborResponse = await this.api.editLaborById({
          costId: this.labor.costId,
          costLaborEditCommand: {
            costId: this.labor.costId,
            laborHours: this.editedItem.laborHours,
            workorderId: this.labor.workorderId,
            laborDate: new Date(
              this.editedItem.laborDate.getTime() -
                this.editedItem.laborDate.getTimezoneOffset() * 60000
            )
          }
        });
        this.$emit('labor-updated', editedLaborResponse);
      } catch (error) {
        this.editorError(error);
      }
      this.popoverOpen = false;
    }
  }

  private async cancelLabor() {
    this.editedItem.laborName = this.labor.laborName;
    this.editedItem.laborHours = this.labor.laborHours;
    this.editedItem.laborDate = this.labor.laborDate;

    this.popoverOpen = false;
  }

  private async editorError(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    let vpd: ValidationProblemDetails;
    if (error instanceof Response) {
      vpd = await error.json();
    } else {
      vpd = error;
    }

    if (vpd.errors) {
      alert(vpd.errors[''][0]);
    }
  }

  get clientSideValidation() {
    return (
      this.editedItem.laborName &&
      this.editedItem.laborHours &&
      this.editedItem.laborHours > 0 &&
      this.editedItem.laborDate
    );
  }

  private calculateLaborDate(inputDate: Date) {
    var dateAdjustedForUTC = new Date(
      inputDate.getUTCFullYear(),
      inputDate.getUTCMonth(),
      inputDate.getUTCDate()
    );
    return dateAdjustedForUTC;
  }
}
